module.exports = __webpack_public_path__ + "img/vide-press.9e6ce1f2.svg";